"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Code from
// https://css-tricks.com/converting-color-spaces-in-javascript/
const convertRGBtoHex = (rgb) => {
    if (rgb.r < 0 || rgb.g < 0 || rgb.b < 0) {
        throw new Error('RGB values cannot be less than 0');
    }
    if (rgb.r > 255 || rgb.g > 255 || rgb.b > 255) {
        throw new Error('RGB values cannot be greater than 255');
    }
    let r = rgb.r.toString(16);
    let g = rgb.g.toString(16);
    let b = rgb.b.toString(16);
    if (r.length === 1)
        r = '0' + r;
    if (g.length === 1)
        g = '0' + g;
    if (b.length === 1)
        b = '0' + b;
    return `#${r}${g}${b}`;
};
exports.default = convertRGBtoHex;
